// source: pushwoosh/accounts/get_auth_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var pushwoosh_objects_restrictionValues_v1_model_pb = require('../../pushwoosh/objects/restrictionValues/v1/model_pb.js');
goog.object.extend(proto, pushwoosh_objects_restrictionValues_v1_model_pb);
var pushwoosh_accounts_accounts_pb = require('../../pushwoosh/accounts/accounts_pb.js');
goog.object.extend(proto, pushwoosh_accounts_accounts_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts_get_auth_info.User', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts_get_auth_info.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.displayName = 'proto.pushwoosh.rpc_v2.accounts_get_auth_info.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.displayName = 'proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.displayName = 'proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest;
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.toObject(includeInstance, f),
    account: (f = msg.getAccount()) && proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse;
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.pushwoosh.rpc_v2.accounts_get_auth_info.User;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.serializeBinaryToWriter
    );
  }
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.serializeBinaryToWriter
    );
  }
};


/**
 * optional User user = 2;
 * @return {?proto.pushwoosh.rpc_v2.accounts_get_auth_info.User}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.getUser = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts_get_auth_info.User, 2));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts_get_auth_info.User|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Account account = 3;
 * @return {?proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.getAccount = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account, 3));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.GetAuthInfoResponse.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    timezone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timezoneOffset: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountsCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    allowNewsletters: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    allowDailyStatsGlobal: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    allowNotificationSubscribers: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    allowNotificationIosLicense: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    allowNotificationUserInactivity: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    allowNotificationDisablePlatform: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    intercomUserHash: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts_get_auth_info.User;
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezoneOffset(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccountsCount(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowNewsletters(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowDailyStatsGlobal(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowNotificationSubscribers(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowNotificationIosLicense(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowNotificationUserInactivity(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowNotificationDisablePlatform(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntercomUserHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimezoneOffset();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountsCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAllowNewsletters();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getAllowDailyStatsGlobal();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getAllowNotificationSubscribers();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getAllowNotificationIosLicense();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getAllowNotificationUserInactivity();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getAllowNotificationDisablePlatform();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIntercomUserHash();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_active = 3;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string timezone = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string timezone_offset = 5;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getTimezoneOffset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setTimezoneOffset = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 accounts_count = 6;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getAccountsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setAccountsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool allow_newsletters = 7;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getAllowNewsletters = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setAllowNewsletters = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool allow_daily_stats_global = 8;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getAllowDailyStatsGlobal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setAllowDailyStatsGlobal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool allow_notification_subscribers = 9;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getAllowNotificationSubscribers = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setAllowNotificationSubscribers = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool allow_notification_ios_license = 10;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getAllowNotificationIosLicense = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setAllowNotificationIosLicense = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool allow_notification_user_inactivity = 11;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getAllowNotificationUserInactivity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setAllowNotificationUserInactivity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool allow_notification_disable_platform = 12;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getAllowNotificationDisablePlatform = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setAllowNotificationDisablePlatform = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string intercom_user_hash = 13;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.getIntercomUserHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.User} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.User.prototype.setIntercomUserHash = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.repeatedFields_ = [82];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isEnterprise: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    expireDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    frozen: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    productType: jspb.Message.getFieldWithDefault(msg, 6, ""),
    domain: jspb.Message.getFieldWithDefault(msg, 7, ""),
    admin: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    restriction: jspb.Message.getFieldWithDefault(msg, 9, ""),
    canUsePacks: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    hasPersonalizationPack: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    hasMarketingPack: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    isUnderSu: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    isAccountLocked: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    isTwoFactorAuthEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    hasActiveOrder: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    registrationDate: (f = msg.getRegistrationDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    appGroupsCount: jspb.Message.getFieldWithDefault(msg, 18, 0),
    applicationsCount: jspb.Message.getFieldWithDefault(msg, 19, 0),
    filtersCount: jspb.Message.getFieldWithDefault(msg, 20, 0),
    tagsCount: jspb.Message.getFieldWithDefault(msg, 21, 0),
    geoZonesCount: jspb.Message.getFieldWithDefault(msg, 22, 0),
    campaignsCount: jspb.Message.getFieldWithDefault(msg, 23, 0),
    presetsCount: jspb.Message.getFieldWithDefault(msg, 24, 0),
    testDevicesCount: jspb.Message.getFieldWithDefault(msg, 25, 0),
    autoPushesCount: jspb.Message.getFieldWithDefault(msg, 26, 0),
    rssFeedsCount: jspb.Message.getFieldWithDefault(msg, 27, 0),
    inAppsCount: jspb.Message.getFieldWithDefault(msg, 28, 0),
    eventsCount: jspb.Message.getFieldWithDefault(msg, 32, 0),
    deeplinksCount: jspb.Message.getFieldWithDefault(msg, 33, 0),
    richMediaCount: jspb.Message.getFieldWithDefault(msg, 34, 0),
    emailTemplatesCount: jspb.Message.getFieldWithDefault(msg, 35, 0),
    accountMailsCount: jspb.Message.getFieldWithDefault(msg, 36, 0),
    accountDomainsCount: jspb.Message.getFieldWithDefault(msg, 37, 0),
    pushAvailableSubscribers: jspb.Message.getFieldWithDefault(msg, 45, 0),
    pushNotAvailableSubscribers: jspb.Message.getFieldWithDefault(msg, 46, 0),
    isDeviceLimitReached: jspb.Message.getBooleanFieldWithDefault(msg, 47, false),
    aceSeeApplications: jspb.Message.getBooleanFieldWithDefault(msg, 60, false),
    aceModifyApplications: jspb.Message.getBooleanFieldWithDefault(msg, 61, false),
    aceSeeAppGroups: jspb.Message.getBooleanFieldWithDefault(msg, 62, false),
    aceModifyAppGroups: jspb.Message.getBooleanFieldWithDefault(msg, 63, false),
    aceSeeMessages: jspb.Message.getBooleanFieldWithDefault(msg, 64, false),
    aceModifyMessages: jspb.Message.getBooleanFieldWithDefault(msg, 65, false),
    aceSendMessages: jspb.Message.getBooleanFieldWithDefault(msg, 66, false),
    aceSeeFilters: jspb.Message.getBooleanFieldWithDefault(msg, 67, false),
    aceModifyFilters: jspb.Message.getBooleanFieldWithDefault(msg, 68, false),
    aceSeeTags: jspb.Message.getBooleanFieldWithDefault(msg, 69, false),
    aceModifyTags: jspb.Message.getBooleanFieldWithDefault(msg, 70, false),
    aceSeeRichMedia: jspb.Message.getBooleanFieldWithDefault(msg, 71, false),
    aceModifyRichMedia: jspb.Message.getBooleanFieldWithDefault(msg, 72, false),
    aceSeeEmailTemplates: jspb.Message.getBooleanFieldWithDefault(msg, 73, false),
    aceModifyEmailTemplates: jspb.Message.getBooleanFieldWithDefault(msg, 74, false),
    aceSuperRight: jspb.Message.getBooleanFieldWithDefault(msg, 75, false),
    aceManageUsers: jspb.Message.getBooleanFieldWithDefault(msg, 76, false),
    aceManageSubscription: jspb.Message.getBooleanFieldWithDefault(msg, 77, false),
    aceSeeApiAccess: jspb.Message.getBooleanFieldWithDefault(msg, 78, false),
    aceDomainAndEmailVerification: jspb.Message.getBooleanFieldWithDefault(msg, 79, false),
    freeEmailLimitUpdateDate: jspb.Message.getFieldWithDefault(msg, 80, ""),
    paidEmailExpireDate: jspb.Message.getFieldWithDefault(msg, 81, ""),
    allowedPlatformsList: (f = jspb.Message.getRepeatedField(msg, 82)) == null ? undefined : f,
    billingAddress: (f = msg.getBillingAddress()) && pushwoosh_accounts_accounts_pb.BillingAddress.toObject(includeInstance, f),
    currentOrder: (f = msg.getCurrentOrder()) && proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.toObject(includeInstance, f),
    restrictions: (f = msg.getRestrictions()) && pushwoosh_objects_restrictionValues_v1_model_pb.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account;
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnterprise(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpireDate(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFrozen(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdmin(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRestriction(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanUsePacks(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasPersonalizationPack(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasMarketingPack(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsUnderSu(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAccountLocked(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsTwoFactorAuthEnabled(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasActiveOrder(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRegistrationDate(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAppGroupsCount(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplicationsCount(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFiltersCount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTagsCount(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGeoZonesCount(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignsCount(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPresetsCount(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTestDevicesCount(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAutoPushesCount(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRssFeedsCount(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInAppsCount(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEventsCount(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeeplinksCount(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRichMediaCount(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEmailTemplatesCount(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountMailsCount(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountDomainsCount(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPushAvailableSubscribers(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPushNotAvailableSubscribers(value);
      break;
    case 47:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeviceLimitReached(value);
      break;
    case 60:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSeeApplications(value);
      break;
    case 61:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceModifyApplications(value);
      break;
    case 62:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSeeAppGroups(value);
      break;
    case 63:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceModifyAppGroups(value);
      break;
    case 64:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSeeMessages(value);
      break;
    case 65:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceModifyMessages(value);
      break;
    case 66:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSendMessages(value);
      break;
    case 67:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSeeFilters(value);
      break;
    case 68:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceModifyFilters(value);
      break;
    case 69:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSeeTags(value);
      break;
    case 70:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceModifyTags(value);
      break;
    case 71:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSeeRichMedia(value);
      break;
    case 72:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceModifyRichMedia(value);
      break;
    case 73:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSeeEmailTemplates(value);
      break;
    case 74:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceModifyEmailTemplates(value);
      break;
    case 75:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSuperRight(value);
      break;
    case 76:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceManageUsers(value);
      break;
    case 77:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceManageSubscription(value);
      break;
    case 78:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceSeeApiAccess(value);
      break;
    case 79:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAceDomainAndEmailVerification(value);
      break;
    case 80:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreeEmailLimitUpdateDate(value);
      break;
    case 81:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaidEmailExpireDate(value);
      break;
    case 82:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAllowedPlatforms(values[i]);
      }
      break;
    case 100:
      var value = new pushwoosh_accounts_accounts_pb.BillingAddress;
      reader.readMessage(value,pushwoosh_accounts_accounts_pb.BillingAddress.deserializeBinaryFromReader);
      msg.setBillingAddress(value);
      break;
    case 101:
      var value = new proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.deserializeBinaryFromReader);
      msg.setCurrentOrder(value);
      break;
    case 102:
      var value = new pushwoosh_objects_restrictionValues_v1_model_pb.RestrictionValue;
      reader.readMessage(value,pushwoosh_objects_restrictionValues_v1_model_pb.RestrictionValue.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsEnterprise();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getExpireDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFrozen();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getProductType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAdmin();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getRestriction();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCanUsePacks();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getHasPersonalizationPack();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getHasMarketingPack();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIsUnderSu();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getIsAccountLocked();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getIsTwoFactorAuthEnabled();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getHasActiveOrder();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getRegistrationDate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAppGroupsCount();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getApplicationsCount();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getFiltersCount();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getTagsCount();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getGeoZonesCount();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getCampaignsCount();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getPresetsCount();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getTestDevicesCount();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getAutoPushesCount();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getRssFeedsCount();
  if (f !== 0) {
    writer.writeInt64(
      27,
      f
    );
  }
  f = message.getInAppsCount();
  if (f !== 0) {
    writer.writeInt64(
      28,
      f
    );
  }
  f = message.getEventsCount();
  if (f !== 0) {
    writer.writeInt64(
      32,
      f
    );
  }
  f = message.getDeeplinksCount();
  if (f !== 0) {
    writer.writeInt64(
      33,
      f
    );
  }
  f = message.getRichMediaCount();
  if (f !== 0) {
    writer.writeInt64(
      34,
      f
    );
  }
  f = message.getEmailTemplatesCount();
  if (f !== 0) {
    writer.writeInt64(
      35,
      f
    );
  }
  f = message.getAccountMailsCount();
  if (f !== 0) {
    writer.writeInt64(
      36,
      f
    );
  }
  f = message.getAccountDomainsCount();
  if (f !== 0) {
    writer.writeInt64(
      37,
      f
    );
  }
  f = message.getPushAvailableSubscribers();
  if (f !== 0) {
    writer.writeInt64(
      45,
      f
    );
  }
  f = message.getPushNotAvailableSubscribers();
  if (f !== 0) {
    writer.writeInt64(
      46,
      f
    );
  }
  f = message.getIsDeviceLimitReached();
  if (f) {
    writer.writeBool(
      47,
      f
    );
  }
  f = message.getAceSeeApplications();
  if (f) {
    writer.writeBool(
      60,
      f
    );
  }
  f = message.getAceModifyApplications();
  if (f) {
    writer.writeBool(
      61,
      f
    );
  }
  f = message.getAceSeeAppGroups();
  if (f) {
    writer.writeBool(
      62,
      f
    );
  }
  f = message.getAceModifyAppGroups();
  if (f) {
    writer.writeBool(
      63,
      f
    );
  }
  f = message.getAceSeeMessages();
  if (f) {
    writer.writeBool(
      64,
      f
    );
  }
  f = message.getAceModifyMessages();
  if (f) {
    writer.writeBool(
      65,
      f
    );
  }
  f = message.getAceSendMessages();
  if (f) {
    writer.writeBool(
      66,
      f
    );
  }
  f = message.getAceSeeFilters();
  if (f) {
    writer.writeBool(
      67,
      f
    );
  }
  f = message.getAceModifyFilters();
  if (f) {
    writer.writeBool(
      68,
      f
    );
  }
  f = message.getAceSeeTags();
  if (f) {
    writer.writeBool(
      69,
      f
    );
  }
  f = message.getAceModifyTags();
  if (f) {
    writer.writeBool(
      70,
      f
    );
  }
  f = message.getAceSeeRichMedia();
  if (f) {
    writer.writeBool(
      71,
      f
    );
  }
  f = message.getAceModifyRichMedia();
  if (f) {
    writer.writeBool(
      72,
      f
    );
  }
  f = message.getAceSeeEmailTemplates();
  if (f) {
    writer.writeBool(
      73,
      f
    );
  }
  f = message.getAceModifyEmailTemplates();
  if (f) {
    writer.writeBool(
      74,
      f
    );
  }
  f = message.getAceSuperRight();
  if (f) {
    writer.writeBool(
      75,
      f
    );
  }
  f = message.getAceManageUsers();
  if (f) {
    writer.writeBool(
      76,
      f
    );
  }
  f = message.getAceManageSubscription();
  if (f) {
    writer.writeBool(
      77,
      f
    );
  }
  f = message.getAceSeeApiAccess();
  if (f) {
    writer.writeBool(
      78,
      f
    );
  }
  f = message.getAceDomainAndEmailVerification();
  if (f) {
    writer.writeBool(
      79,
      f
    );
  }
  f = message.getFreeEmailLimitUpdateDate();
  if (f.length > 0) {
    writer.writeString(
      80,
      f
    );
  }
  f = message.getPaidEmailExpireDate();
  if (f.length > 0) {
    writer.writeString(
      81,
      f
    );
  }
  f = message.getAllowedPlatformsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      82,
      f
    );
  }
  f = message.getBillingAddress();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      pushwoosh_accounts_accounts_pb.BillingAddress.serializeBinaryToWriter
    );
  }
  f = message.getCurrentOrder();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.serializeBinaryToWriter
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      pushwoosh_objects_restrictionValues_v1_model_pb.RestrictionValue.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order;
  return proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_enterprise = 3;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getIsEnterprise = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setIsEnterprise = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string expire_date = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getExpireDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setExpireDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool frozen = 5;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getFrozen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setFrozen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string product_type = 6;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getProductType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setProductType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string domain = 7;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool admin = 8;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAdmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAdmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string restriction = 9;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getRestriction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setRestriction = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool can_use_packs = 10;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getCanUsePacks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setCanUsePacks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool has_personalization_pack = 11;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getHasPersonalizationPack = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setHasPersonalizationPack = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool has_marketing_pack = 12;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getHasMarketingPack = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setHasMarketingPack = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool is_under_su = 13;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getIsUnderSu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setIsUnderSu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool is_account_locked = 14;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getIsAccountLocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setIsAccountLocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool is_two_factor_auth_enabled = 15;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getIsTwoFactorAuthEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setIsTwoFactorAuthEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool has_active_order = 16;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getHasActiveOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setHasActiveOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp registration_date = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getRegistrationDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
*/
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setRegistrationDate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.clearRegistrationDate = function() {
  return this.setRegistrationDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.hasRegistrationDate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional int64 app_groups_count = 18;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAppGroupsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAppGroupsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 applications_count = 19;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getApplicationsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setApplicationsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 filters_count = 20;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getFiltersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setFiltersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 tags_count = 21;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getTagsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setTagsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 geo_zones_count = 22;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getGeoZonesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setGeoZonesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 campaigns_count = 23;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getCampaignsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setCampaignsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int64 presets_count = 24;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getPresetsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setPresetsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 test_devices_count = 25;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getTestDevicesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setTestDevicesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 auto_pushes_count = 26;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAutoPushesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAutoPushesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int64 rss_feeds_count = 27;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getRssFeedsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setRssFeedsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional int64 in_apps_count = 28;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getInAppsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setInAppsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * optional int64 events_count = 32;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getEventsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setEventsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional int64 deeplinks_count = 33;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getDeeplinksCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setDeeplinksCount = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional int64 rich_media_count = 34;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getRichMediaCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setRichMediaCount = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional int64 email_templates_count = 35;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getEmailTemplatesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setEmailTemplatesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional int64 account_mails_count = 36;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAccountMailsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAccountMailsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional int64 account_domains_count = 37;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAccountDomainsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAccountDomainsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * optional int64 push_available_subscribers = 45;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getPushAvailableSubscribers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setPushAvailableSubscribers = function(value) {
  return jspb.Message.setProto3IntField(this, 45, value);
};


/**
 * optional int64 push_not_available_subscribers = 46;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getPushNotAvailableSubscribers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setPushNotAvailableSubscribers = function(value) {
  return jspb.Message.setProto3IntField(this, 46, value);
};


/**
 * optional bool is_device_limit_reached = 47;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getIsDeviceLimitReached = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 47, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setIsDeviceLimitReached = function(value) {
  return jspb.Message.setProto3BooleanField(this, 47, value);
};


/**
 * optional bool ace_see_applications = 60;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSeeApplications = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 60, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSeeApplications = function(value) {
  return jspb.Message.setProto3BooleanField(this, 60, value);
};


/**
 * optional bool ace_modify_applications = 61;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceModifyApplications = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 61, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceModifyApplications = function(value) {
  return jspb.Message.setProto3BooleanField(this, 61, value);
};


/**
 * optional bool ace_see_app_groups = 62;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSeeAppGroups = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 62, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSeeAppGroups = function(value) {
  return jspb.Message.setProto3BooleanField(this, 62, value);
};


/**
 * optional bool ace_modify_app_groups = 63;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceModifyAppGroups = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 63, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceModifyAppGroups = function(value) {
  return jspb.Message.setProto3BooleanField(this, 63, value);
};


/**
 * optional bool ace_see_messages = 64;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSeeMessages = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 64, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSeeMessages = function(value) {
  return jspb.Message.setProto3BooleanField(this, 64, value);
};


/**
 * optional bool ace_modify_messages = 65;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceModifyMessages = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 65, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceModifyMessages = function(value) {
  return jspb.Message.setProto3BooleanField(this, 65, value);
};


/**
 * optional bool ace_send_messages = 66;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSendMessages = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 66, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSendMessages = function(value) {
  return jspb.Message.setProto3BooleanField(this, 66, value);
};


/**
 * optional bool ace_see_filters = 67;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSeeFilters = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 67, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSeeFilters = function(value) {
  return jspb.Message.setProto3BooleanField(this, 67, value);
};


/**
 * optional bool ace_modify_filters = 68;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceModifyFilters = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 68, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceModifyFilters = function(value) {
  return jspb.Message.setProto3BooleanField(this, 68, value);
};


/**
 * optional bool ace_see_tags = 69;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSeeTags = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 69, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSeeTags = function(value) {
  return jspb.Message.setProto3BooleanField(this, 69, value);
};


/**
 * optional bool ace_modify_tags = 70;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceModifyTags = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 70, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceModifyTags = function(value) {
  return jspb.Message.setProto3BooleanField(this, 70, value);
};


/**
 * optional bool ace_see_rich_media = 71;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSeeRichMedia = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 71, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSeeRichMedia = function(value) {
  return jspb.Message.setProto3BooleanField(this, 71, value);
};


/**
 * optional bool ace_modify_rich_media = 72;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceModifyRichMedia = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 72, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceModifyRichMedia = function(value) {
  return jspb.Message.setProto3BooleanField(this, 72, value);
};


/**
 * optional bool ace_see_email_templates = 73;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSeeEmailTemplates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 73, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSeeEmailTemplates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 73, value);
};


/**
 * optional bool ace_modify_email_templates = 74;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceModifyEmailTemplates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 74, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceModifyEmailTemplates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 74, value);
};


/**
 * optional bool ace_super_right = 75;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSuperRight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 75, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSuperRight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 75, value);
};


/**
 * optional bool ace_manage_users = 76;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceManageUsers = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 76, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceManageUsers = function(value) {
  return jspb.Message.setProto3BooleanField(this, 76, value);
};


/**
 * optional bool ace_manage_subscription = 77;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceManageSubscription = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 77, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceManageSubscription = function(value) {
  return jspb.Message.setProto3BooleanField(this, 77, value);
};


/**
 * optional bool ace_see_api_access = 78;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceSeeApiAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 78, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceSeeApiAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 78, value);
};


/**
 * optional bool ace_domain_and_email_verification = 79;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAceDomainAndEmailVerification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 79, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAceDomainAndEmailVerification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 79, value);
};


/**
 * optional string free_email_limit_update_date = 80;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getFreeEmailLimitUpdateDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 80, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setFreeEmailLimitUpdateDate = function(value) {
  return jspb.Message.setProto3StringField(this, 80, value);
};


/**
 * optional string paid_email_expire_date = 81;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getPaidEmailExpireDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 81, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setPaidEmailExpireDate = function(value) {
  return jspb.Message.setProto3StringField(this, 81, value);
};


/**
 * repeated uint32 allowed_platforms = 82;
 * @return {!Array<number>}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getAllowedPlatformsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 82));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setAllowedPlatformsList = function(value) {
  return jspb.Message.setField(this, 82, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.addAllowedPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 82, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.clearAllowedPlatformsList = function() {
  return this.setAllowedPlatformsList([]);
};


/**
 * optional pushwoosh.rpc_v2.accounts.BillingAddress billing_address = 100;
 * @return {?proto.pushwoosh.rpc_v2.accounts.BillingAddress}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getBillingAddress = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.BillingAddress} */ (
    jspb.Message.getWrapperField(this, pushwoosh_accounts_accounts_pb.BillingAddress, 100));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.BillingAddress|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
*/
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setBillingAddress = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.clearBillingAddress = function() {
  return this.setBillingAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.hasBillingAddress = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional Order current_order = 101;
 * @return {?proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getCurrentOrder = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order, 101));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.Order|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
*/
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setCurrentOrder = function(value) {
  return jspb.Message.setWrapperField(this, 101, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.clearCurrentOrder = function() {
  return this.setCurrentOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.hasCurrentOrder = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional pushwoosh.objects.restrictionValues.v1.RestrictionValue restrictions = 102;
 * @return {?proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.getRestrictions = function() {
  return /** @type{?proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, pushwoosh_objects_restrictionValues_v1_model_pb.RestrictionValue, 102));
};


/**
 * @param {?proto.pushwoosh.objects.restrictionValues.v1.RestrictionValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
*/
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 102, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts_get_auth_info.Account.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 102) != null;
};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.accounts_get_auth_info);
